import isFormatSupported from "@/utils/isFormatSupported";
import preloadImage from "@/utils/preloadImage";

export default function (element, data) {
    const frames = data.framesNum;
    const fps = data.fps;
    const baseUrl = data.baseUrl;
    const frameDuration = 1000 / fps;
    const startTime = performance.now();
    let prevFrameIndex = null;

    let format = "avif";
    (async function () {
        if (await isFormatSupported("avif")) {
            format = "avif";
        } else if (await isFormatSupported("webp")) {
            format = "webp";
        } else {
            format = "png";
        }

        await preloadFrames(baseUrl, frames, format);
    })();

    requestAnimationFrame(animate);

    function animate() {
        const elapsed = performance.now() - startTime;
        const cycleLength = (frames - 1) * 2;
        let position = Math.floor(elapsed / frameDuration) % cycleLength;

        let frameIndex;
        if (position < frames - 1) {
            frameIndex = position + 1;
        } else {
            frameIndex = frames - (position - (frames - 2));
        }

        if (frameIndex !== prevFrameIndex) {
            element.src = formatFrameUrl(baseUrl, format, frameIndex);
            prevFrameIndex = frameIndex;
        }

        requestAnimationFrame(animate);
    }

};

async function preloadFrames(baseUrl, framesNum, format) {
    for (let i = 1; i <= framesNum; i++) {
        const currentFrameUrl = formatFrameUrl(baseUrl, format, i);
        await preloadImage(currentFrameUrl);
    }
}

function formatFrameUrl(baseUrl, format, frameNumber) {
    const paddedFrameNumber = ('0000' + frameNumber).slice(-4);
    return baseUrl + "/" + format + "/frame_" + paddedFrameNumber + "." + format;
}
